import { StreamActions } from '@hotwired/turbo'
import Toast from '/libs/toast'

StreamActions.toast = function() {
  const message = this.getAttribute('message')
  const type = this.getAttribute('type')
  new Toast(message, { type: type }).show()
}
